export const messages = {
  pl: {
    message: {
      // ---------------------------------------------------------- MENU
      zapisz: 'Zapisz konfiguracje',
      otworz: 'Otwórz konfiguracje',
      drukuj: 'drukuj',
      export_pdf: 'eksport(*.pdf)',
      export_csv: 'eksport(*.csv)',
      wyjscie: 'wyjście',
      o_programie: 'O programie',
      instrukcja_programu: 'Instrukcja programu',
      dokumentacja: 'Dokumentacja',
      wroc: 'wróć',
      pliki: 'pliki CONFI-DSO',
      wyslij_zapytanie: 'Wyślij zapytanie',
      dane_adresowe: 'Dane adresowe',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      input_data: 'Dane wejściowe',
      czas_podtrzymania: 'Czas podtrzymania [h]',
      czas_alarmowania: 'Czas alarmowania [h]',
      dodatkowe_u: 'Dodatkowe miejsce U w szafie',
      sieciowanie: 'Sieciowanie systemu',
      glebokosc_szafy: 'Głębokość szafy',
      tryb_poboru: 'Tryb poboru mocy po awarii zasilania sieciowego',
      devices: 'Urządzenia',
      glowne: 'Główne',
      pozostale: 'Pozostałe',
      wzmacniacz: 'Wzmacniacz PVA-2P500',
      wzmacniacz_rez: 'Wzmacniacz - rezerwowy',
      kontroler: 'Kontroler PVA-4CR12',
      router: 'Router PVA-4R24',
      mikrofon: 'Mikrofon strażaka PVA-15CST',
      w_szafie: 'w szafie',
      poza_szafa: 'poza szafą',
      w_obudowie: 'w obudowie',
      w_ob_zasilacz: 'w ob. + zasilacz',
      rozszerzenie: 'rozszerzenia',
      wariant: 'wariant',
      plytki_konca: 'Obudowa płytki końca lini',
      panel_wentyl: 'Panel wentylacyjny z termostatem',
      zestaw_kolek: 'Zestaw kółek',
      adapter_zasilacz: 'Zasilacz EN54-2A17 + adapter zasilania AWO627',
      metoda_kontroli: 'Metoda kontroli lini głośnikowych',
      sygnal_pilota: '20kHz sygnałem pilota [W]',
      moc_glosnikow: 'Moc zainstalowanych głośników [W]',
      moc_systemu: 'Dostępna moc systemu [W]',
      mikrofon_poza: 'Mikrofon strażaka poza szafą',
      // ---------------------------------------------------------- DANE WYJŚCIOWE
      output_data: 'Dane wyjściowe',
      moc_naglosnienia: 'Max. moc nagłośnienia [W] ',
      liczba_lini: 'Max. liczba linii głośnikowych',
      moc_zasilacza: 'Moc zasilacza [W]',
      akumulatory: 'Typ akumulatorów [Ah]',
      liczba_akumulatorow: 'Liczba akumulatorów [szt]',
      zapas_poj_akum: 'Zapas pojemności akumulatorów [Ah]',
      przylacze: 'Przyłącze zasilania [V]',
      max_pobor_pradu: 'Max. pobór prądu z sieci [A]',
      max_moc_cieplna: 'Max. moc cieplna oddawana do otoczenia [W]',
      zabez_bezp: 'Zabezpieczenie bezpiecznikowe [A]',
      wolne_u: 'Wolne miejsce w szafie RACK [U]',
      wys_szafy: 'Wysokość szafy RACK [U]',
      wys_szafy_mm: 'Wysokość szafy RACK [mm]',
      rozmiar_szafy: 'Rozmiar szafy RACK [mm]',
      waga_szafy: 'Waga szafy [kg]',
      waga_akum: 'Waga akumulatorów [kg]',
      waga_instal: 'Waga instalacyjna(z akumulatorami i urządzeniami) [kg]',
      faza1: '1-fazowe 230',
      faza3: '3-fazowe 3x230/400',
      // ---------------------------------------------------------- GLOBAL
      lp: 'Lp',
      coop: 'przy współpracy z firmą',
      code: 'kod producenta',
      system: 'System',
      kod: 'Kod',
      nazwa: 'Nazwa',
      cena: 'Cena[PLN]',
      ceny: 'Ceny[PLN]',
      cena_netto_szt: 'Cena netto sztuka',
      cena_systemu: 'Cena netto systemu DSOP24V [PLN]',
      cena_cala: 'Całkowita cena netto [PLN]',
      cena_net_sztuka: 'Cena netto przed rabatem [PLN]',
      cena_net_szt_pln: 'Cena netto sztuka po rabacie [PLN]',
      waga: 'Waga [kg]',
      ilosc_sztuk: 'Ilość Sztuk',
      ilosc: 'Ilość',
      calosc: 'Całość',
      rabat: 'Rabat',
      rabat_cenowy: 'Rabat cenowy [%]',
      przed_rabatem: 'przed rabatem',
      wielkosc_rabatu: 'wielkość rabatu',
      wartosc_net: 'Wartość netto',
      wartosc_net_rabat: 'Wartość netto po rabacie',
      opis: 'Opis',
      lista: 'Lista produktów',
      razem: 'Razem',
      razem_pln: 'Razem [PLN]',
      numer_konfi: 'Numer konfiguracji',
      rezerwowy: 'rezerwowy',
      ciag: 'ciąg',
      pojemnosc: 'poj',
      kontakt: '',
      nie: 'nie',
      tak: 'tak',
      wycena: 'Wycena',
      // ---------------------------------------------------------- AKTUALNE DANE
      akt_confi: 'Aktualna konfiguracja',
      konfiguracja_szafa: 'Szafa',
      konfiguracja_zasilacz: 'Zasilacz',
      konfiguracja_listwaD: 'Listwa Dystrybucji',
      konfiguracja_listwaZ: 'Listwa Zasilania',
      konfiguracja_akum: 'Akumulatory',
      konfiguracja_akum_1: 'Akumulator',
      konfiguracja_wzmacniacz: 'Wzmacniacz',
      konfiguracja_wzmacniacz_rez: 'Wzmacniacz rez.',
      konfiguracja_kontroler: 'Kontroler',
      konfiguracja_router: 'Router',
      konfiguracja_mikrofon: 'Mikrofon strażaka',
      // ---------------------------------------------------------- KALENDARZ
      styczen: 'Styczeń',
      luty: 'Luty',
      marzec: 'Marzec',
      kwiecien: 'Kwiecień',
      maj: 'Maj',
      czerwiec: 'Czerwiec',
      lipiec: 'Lipiec',
      sierpien: 'Sierpień',
      wrzesien: 'Wrzesień',
      pazdziernik: 'Październik',
      listopad: 'Listopad',
      grudzien: 'Grudzień',
      // ---------------------------------------------------------- PRZYCISKI
      dokumentacja_big: 'DOKUMENTACJA',
      zapytanie_big: 'WYŚLIJ ZAPYTANIE',
      wyslij: 'wyślij',
      zestawienie: 'pokaż zestawienie',
      wynik: 'pokaż wynik',
      wczytaj_logo: 'wczytaj logo',
      zapisz_formularz: 'zapisz',
      zalacz_plik: 'załącz plik',
      przegladaj: 'przeglądaj...',
      zmien: 'zmień',
      pomin: 'pomiń',
      zamknij: 'zamknij',
      // ---------------------------------------------------------- POLA ADRES
      dane_kontaktowe: 'Dane kontaktowe',
      firma: 'Firma',
      firma_zamaw: 'Firma zamawiająca',
      zamawiajacy: 'Zamawiający',
      nazwa_firmy: 'Nazwa firmy',
      adres: 'Adres',
      adres_inwest: 'Adres inwestycji',
      adres_wysylki: 'Adres wysyłki',
      miasto: 'Miasto',
      ulica: 'Ulica',
      telefon: 'Telefon',
      tel: 'Tel',
      tel_kontakt: 'Telefon kontaktowy',
      email: 'e-Mail',
      email_kontakt: 'e-mail kontaktowy',
      stanowisko: 'Stanowisko',
      tresc: 'Treść',
      nip: 'NIP',
      inwestycja: 'Inwestycja',
      nazwa_inwest: 'Nazwa inwestycji',
      biuro: 'Nazwa biura projektowego / projektanta',
      inny_adres: 'zaznacz jeżeli inny adres wysyłki',
      imie: 'Imię i nazwisko',
      puste_pola: 'proszę uzupełnić pola',
      // ---------------------------------------------------------- KOMUNIKATY
      skontaktuj: '',
      drukuj_z_cenami: 'drukuj z cenami',
      drukuj_bez_cen: 'drukuj bez cen',
      wyslano_zapytanie: 'Wysłano zapytanie.',
      plik_zalacz: 'plik załączony',
      zaladowany: 'załadowany',
      blad: 'Błąd',
      aktualizacja: 'Aktualizacja',
      uwaga: 'Uwaga',
      informacja: 'Informacja',
      skonfiguruj: 'Proszę skonfigurować SYSTEM DSO',
      drukowanie: 'Po chwili rozpocznie się drukowanie.',
      kolizja: 'Kolizja elementów',
      brak_miejsca_szafa: 'Brak miejsca w szafie.',
      duza_liczba_elem: 'Zbyt duża liczba elementów w szafie.',
      info_metoda_kontroli: 'Proszę uzupełnić: metodę kontroli linii',
      brak_miejsca: 'Brak miejsc',
      zmiana_akum_zasil: 'Nastąpiła zmiana wartości: - pojemności akumulatora - moc zasilacza',
      zmiana_akum: 'Nastąpiła zmiana wartości: - pojemności akumulatora',
      zmiana_wartosci: 'Zmiana wartości pojemności akumulatora, w wyniku przeliczeń całego systemu.',
      certy: 'CERTYFIKAT STAŁOŚCI WŁAŚCIWOŚCI UŻYTKOWYCH',
      sw_dop: 'ŚWIADECTWO DOPUSZCZENIA',
      dek_we: 'DEKLARACJA ZGODNOŚCI WE',
      dek_wu: 'DEKLARACJA WŁAŚCIWOŚCI UŻYTKOWYCH',
      certy_paviro: 'CERTYFIKAT STAŁOŚCI WŁAŚCIWOŚCI UŻYTKOWYCH - PAVIRO',
      sw_dop_paviro: 'ŚWIADECTWO DOPUSZCZENIA - PAVIRO',
      karta: 'KARTA KATALOGOWA',
      instrukcja: 'Instrukcja',
      lista_kodow: 'LISTA KODÓW AWARII ZASILACZA',
      procedura: 'PROCEDURA SPRAWDZANIA SYSTEMU DSO I WARUNKI GWARANCJI',
      instrukcja_dso: 'INSTRUKCJA PROGRAMU CONFI-DSO',
      brak_akum: 'Brak akumulatora spełniającego zadaną konfigurację systemu DSO, zmień glębokość szafy.',
      mozliwa_800: 'Mozliwość wybrania szafy o głębokości 800',
      koncowka: 'Jeżeli plik zapisany z konfiguracją utraci rozszerzenie (ikona pusta, nie powiązany z żadną aplikacją), proszę dopisać ".xml". Za utrudnienia i niedogodności przepraszamy.',
      rezerwacja: 'Miejsca zarezerwowane dla sprzętu ustalonego z góry - akumulatora - listwe zabezpieczającą - panel sygnalizacyjny / zaślepiający - zasilacz musi być wolne.',
      // ---------------------------------------------------------- INFORMACJE
      wybierz_akumulatory: 'Wybierz akumulatory',
      sieciowanie_info: 'Zaznaczyć tylko w szafie,w której<br>zainstalowano switch sieciowy.',
      info_do_80: 'Odległość do 80m, nie wymaga zasilacza w obudowie.',
      info_po_80: 'W przypadku znacznych odległości od DSO wymagany jest zasilacz lokalny.',
      glebokosc_szafy_info: 'Głębokość szafy 600 lub 800mm<br>w zależności od wysokości szafy.',
      info_rabat: 'O ustalenie rabatu dla systemu zasilania DSO,<br>prosimy o kontakt z działem handlowym.<br>tel: (14) 610-19-41,<br>e-mail: zamowienia@pulsar.pl.',
      info_akum: 'Możliwość doboru zestawu akumulatorów, według własnych potrzeb.',
      info_coop: 'Program stworzony przy współpracy inżynierów z firmy',
      other_akum: 'Pozostałe akumulatory spełniające konfigurację DSO',
      wariant1_title: 'Wariant 1 - "W szafie".',
      wariant1: 'Mikrofon umieszczony w szafie DSO.',
      wariant2_title: 'Wariant 2 - "Poza szafą DSO".',
      wariant2: 'Mikrofon umieszczony poza szafą DSO.',
      wariant3_title: 'Wariant 3 - "W obudowie".',
      wariant3: 'Mikrofon strażaka umieszczony w zewnętrznej obudowie DSOS24VPU.',
      wariant4_title: 'Wariant 4 - "W obudowie z zasilaczem"',
      wariant4: 'Mikrofon strażaka umieszczony w zewnętrznej obudowie DSOS24V.',
      wariant5_title: 'Wariant 5 - "W obudowie z zew. zasilaczem"',
      wariant5: 'Mikrofon strażaka umieszczony poza szafą DSO i zasilany z zewnętrznego zasilacza EN54-2A17.',
      info_system_dso: ' System zasilania DSO System zasilania DSOP24V przeznaczony jest do bezprzerwowego zasilania urządzeń Dźwiękowego Systemu Ostrzegawczego DSO wymagających stabilizowanego napięcia 24VDC (-15%, +20%). Oprócz standardowego wyposażenia systemu DSOP24V dołożono szereg funkcji i narzędzi dodatkowych ułatwiających wykonawcy dobranie sprzętu, wycenę, instalację i uruchomienie. System uruchamiany w 100% przez instalatora<br>– prosta i intuicyjna procedura dla kalibracji akumulatorów, sprawdzenia systemu DSO i zrealizowania protokołu sprawdzenia akumulatorów. Zdalny monitoring systemu DSO z wykorzystaniem wbudowanego serwera www odbywa się on-line przez przeglądarkę internetową z komputera PC. Aplikacja CONFI-DSO<br>- ogólnodostępne narzędzie do budowy i doboru komponentów systemu DSO: - współpraca on-line, możliwość zapisu na dysku itp.<br>- zasilacze DSO dostępne w czterech wariantach mocy 320W / 500W / 750W / 1000W<br>- odpowiedni dobór akumulatorów<br>– 10 różnych pojemności od 35Ah do 230Ah<br>- ograniczenie ilości obwodów (ciągów) akumulatorów do maksymalnie dwóch. O ustalenie rabatu dla systemu zasilania DSO, proszę o kontakt z działem handlowym. Dla powyższego systemu nie obowiązują dotychczasowe ustalone rabaty. ',
      wersja_2_4: 'Wersja aplikacji: 2.4<br> - dodanie opcji sieciowanie systemu. Zaznaczyć tylko w szafie w której zainstalowano switch sieciowy. ',
      wersja_2_3: 'Wersja aplikacji: 2.3<br> - dodanie możliwość montażu szafy na kółkach. Zestaw kółek zawiera 2x kółka bez blokady, 2x kółka z blokadą oraz 2x belka mocująca.',
      wersja_2_2: 'Wersja aplikacji: 2.2<br> - dodanie wariant Mikrofonu strażaka umieszczony poza szafą DSO i zasilany z zewnętrznego zasilacza EN54-2A17.',
      // ---------------------------------------------------------- POLA DO DRUKU
      sys_zasilania: 'System zasilania DSO',
      system_zasilania: 'System zasilania DSOP24V',
      wydruk: 'wydruk CONFI-DSO',
      trans: '- wycena nie zawiera kosztu transportu',
      info_o_zamowieniu: '- przed złożeniem zamówienia prosimy o ponowne sprawdzenie konfiguracji ze względu na możliwe zmiany cen poszczególnych elementów składowych systemu',
      linie_glosnikowe: 'Linie głośnikowe kontrolowane sygnałem pilota',
      wyposazenie: 'Wyposażenie dodatkowe',
      txtAWO506: 'AWO506 - obudowa płytki końca lini',
      txtDSOS24VPU: 'DSOS24VPU - obudowa mikrofonu strażaka',
      txtDSOS24V: 'DSOS24V - zasilacz mikrofonu strażaka',
      txtEN54_2A17: 'EN54-2A17 - zasilacz do systemów przeciwpożarowych',
      txtAWZ627: 'AWZ627 - adapter zasilacza',
      copyright: 'Copyright © Pulsar Sp.j. 1994÷2017. Wszelkie prawa zastrzeżone.',
      obudowa_mikrofonu: 'Obudowa mikrofonu strażaka',
      zasilacz_mikrofonu: 'Zasilacz mikrofonu strażaka'
    }
  },
  en: {
    message: {
      // ---------------------------------------------------------- MENU
      zapisz: 'Save configurations',
      otworz: 'Open configurations',
      drukuj: 'print',
      export_pdf: 'export(*.pdf)',
      export_csv: 'export(*.csv)',
      wyjscie: 'exit',
      o_programie: 'About program',
      instrukcja: 'Program instruction',
      dokumentacja: 'Documentation',
      wroc: 'return',
      pliki: 'CONFI-DSO files',
      wyslij_zapytanie: 'Send question',
      dane_adresowe: 'Address data',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      input_data: 'Input data',
      czas_podtrzymania: 'Hold time [h]',
      czas_alarmowania: 'Alarm time [h]',
      dodatkowe_u: 'Extra space U in the cabinet',
      sieciowanie: 'System networking',
      glebokosc_szafy: 'Rack depth',
      tryb_poboru: 'Power mode after power failure',
      devices: 'Devices',
      glowne: 'Main',
      pozostale: 'Others',
      wzmacniacz: 'PVA-2P500 Amplifier',
      wzmacniacz_rez: 'Amplifier - reserve',
      kontroler: 'PVA-4CR12 Controller',
      router: 'PVA-4R24 Router',
      mikrofon: 'PVA-15CST firefighter microphone',
      w_szafie: 'in cabinet',
      poza_szafa: 'outside',
      w_obudowie: 'in enclosure',
      w_ob_zasilacz: 'in enclosure+PSU',
      rozszerzenie: 'extension',
      wariant: 'option',
      plytki_konca: 'Enclosure for loudspeaker line supervision',
      panel_wentyl: 'Fan unit with thermostat',
      zestaw_kolek: 'Wheels set',
      adapter_zasilacz: 'EN54-2A17 power supply + power supply adapter AWO627',
      metoda_kontroli: 'Speaker Line Control Method',
      sygnal_pilota: '20 kHz pilot tone [W]',
      moc_glosnikow: 'The installed loudspeaker power [W]',
      moc_systemu: 'The available system power [W]',
      mikrofon_poza: 'Firefighter`s microphone mounted outside',
      // ---------------------------------------------------------- DANE WYJŚCIOWE
      output_data: 'Output data',
      moc_naglosnienia: 'Max. Power of sound [W]',
      liczba_lini: 'Max. Number of speaker lines',
      moc_zasilacza: 'PSU power',
      akumulatory: 'Type of batteries [Ah]',
      liczba_akumulatorow: 'Number of batteries [pcs]',
      zapas_poj_akum: 'Battery capacity [Ah]',
      przylacze: 'Power connection [V]',
      max_pobor_pradu: 'Max. Current consumption [A]',
      max_moc_cieplna: 'Max. Heat output to the environment [W]',
      zabez_bezp: 'Fuse protection [A]',
      wolne_u: 'Free space in RACK [U]',
      wys_szafy: 'Rack height [U]',
      wys_szafy_mm: 'Rack height [mm]',
      rozmiar_szafy: 'Rack size [mm]',
      waga_szafy: 'Rack weight [kg]',
      waga_akum: 'Battery weight [kg]',
      waga_instal: 'Installation scale (with batteries and appliances)[kg]',
      faza1: '1-phase 230',
      faza3: '3-phase 3x230/400',
      // ---------------------------------------------------------- GLOBAL
      lp: 'No.',
      coop: 'in cooperation with the company',
      code: 'manufacturer code',
      system: 'System',
      kod: 'Code',
      nazwa: 'Name',
      cena: '',
      ceny: '',
      cena_netto_szt: '',
      cena_systemu: '',
      cena_cala: '',
      cena_net_sztuka: '',
      cena_net_szt_pln: '',
      waga: 'Weight [kg]',
      ilosc_sztuk: 'Number of pieces',
      ilosc: 'Quantity',
      calosc: 'Totality',
      rabat: '',
      rabat_cenowy: '',
      przed_rabatem: '',
      wielkosc_rabatu: '',
      wartosc_net: '',
      wartosc_net_rabat: '',
      opis: 'Description',
      lista: 'List of products',
      razem: 'Totality',
      razem_pln: 'Totality',
      numer_konfi: 'Configuration no.',
      rezerwowy: 'reserve',
      ciag: 'string',
      pojemnosc: 'capacity',
      kontakt: 'For a quotation please contact our sales department: sales@pulsar.pl, tel. +48 14 610 19 45 ',
      nie: 'no',
      tak: 'yes',
      wycena: 'Summary',
      // ---------------------------------------------------------- AKTUALNE DANE
      akt_confi: 'Current configuration',
      konfiguracja_szafa: 'Cabinet',
      konfiguracja_zasilacz: 'Power Supply',
      konfiguracja_listwaD: 'Distribution Plate',
      konfiguracja_listwaZ: 'Power strip',
      konfiguracja_akum: 'Batteries',
      konfiguracja_akum_1: 'Battery',
      konfiguracja_wzmacniacz: 'Amplifier',
      konfiguracja_wzmacniacz_rez: 'Amplifier reserve',
      konfiguracja_kontroler: 'controller',
      konfiguracja_router: 'Router',
      konfiguracja_mikrofon: 'Firefighter’s mic.',
      // ---------------------------------------------------------- KALENDARZ
      styczen: 'January',
      luty: 'February',
      marzec: 'March',
      kwiecien: 'April',
      maj: 'May',
      czerwiec: 'June',
      lipiec: 'July',
      sierpien: 'August',
      wrzesien: 'September',
      pazdziernik: 'October',
      listopad: 'November',
      grudzien: 'December',
      // ---------------------------------------------------------- PRZYCISKI
      dokumentacja_big: 'DOCUMENTATION',
      zapytanie_big: 'SEND QUESTION',
      wyslij: 'send',
      zestawienie: 'show a summary',
      wynik: 'show the result',
      wczytaj_logo: 'load logo',
      zapisz_formularz: 'save',
      zalacz_plik: 'attach file',
      przegladaj: 'browse...',
      zmien: 'change',
      pomin: 'skip',
      zamknij: 'close',
      // ---------------------------------------------------------- POLA ADRES
      dane_kontaktowe: 'Contact details',
      firma: 'Company',
      firma_zamaw: 'Contracting company',
      zamawiajacy: 'Purchaser',
      nazwa_firmy: 'Company name',
      adres: 'Address',
      adres_inwest: 'Address',
      adres_wysylki: 'Shipping address',
      miasto: 'City',
      ulica: 'Street',
      telefon: 'Phone',
      tel: 'Phone',
      tel_kontakt: 'Phone number',
      email: 'e-mail',
      email_kontakt: 'e-mail Contact',
      stanowisko: 'Position',
      tresc: 'Contents',
      nip: 'NIP',
      inwestycja: 'Investment',
      nazwa_inwest: 'Name of the investment',
      biuro: 'Design office / designer name',
      inny_adres: 'check if another shipping address',
      imie: 'Name and last name',
      puste_pola: 'please fill in the fields',
      // ---------------------------------------------------------- KOMUNIKATY
      skontaktuj: 'contact the sales department',
      drukuj_z_cenami: 'print with price',
      drukuj_bez_cen: 'print',
      wyslano_zapytanie: 'A query has been sent.',
      plik_zalacz: 'attached file',
      zaladowany: 'loaded',
      blad: 'Error',
      aktualizacja: 'Update',
      uwaga: 'Warning',
      informacja: 'Information',
      skonfiguruj: 'Please configure your VAS SYSTEM',
      drukowanie: 'Please wait, printing ...',
      kolizja: 'Collision of elements',
      brak_miejsca_szafa: 'No space in the cabinet.',
      duza_liczba_elem: 'Too many elements in the cabinet.',
      info_metoda_kontroli: 'Please complete: line control method',
      brak_miejsca: 'Full cabinet',
      zmiana_akum_zasil: 'The following values have changed: - Battery capacity - PSU power',
      zmiana_akum: 'The following values have changed: - Battery capacity',
      zmiana_wartosci: 'Change in the battery capacity as a result of the whole system conversion.',
      certy: 'CERTIFICATE OF CONSTANCY OF PERFORMANCE',
      sw_dop: 'CERTIFICATE OF APPROVAL',
      dek_we: 'DECLARATION OF CONFORMITY',
      dek_wu: 'DECLARATION OF PERFORMANCE',
      certy_paviro: 'CERTIFICATE OF CONSTANCY OF PERFORMANCE - PAVIRO',
      sw_dop_paviro: 'CERTIFICATE OF APPROVAL - PAVIRO',
      karta: 'DATA SHEET',
      instrukcja_programu: 'Instruction',
      lista_kodow: 'THE LIST OF FAILURE CODES OF THE POWER SUPPLY UNIT',
      procedura: 'THE PROCEDURE FOR CHECKING THE DSO AND THE WARRANTY CONDITIONS',
      instrukcja_dso: 'PROGRAM INSTRUCTION CONFI-DSO',
      brak_akum: 'If no battery meets the voice alarm system configuration, change the cabinet depth.',
      mozliwa_800: 'Mozliwość wybrania szafy o głębokości 800',
      koncowka: 'If the saved configuration files loses the extension (empty icon, not associated with any application), please add ".xml". We apologize for any inconvenience.',
      rezerwacja: 'Space reserved for a predetermined hardware - Battery - Safety Strip - Indication Panel / Blanking Panel - Power Supply Unit - must be free.',
      // ---------------------------------------------------------- INFORMACJE
      wybierz_akumulatory: 'Choose batteries',
      sieciowanie_info: 'Set only in the cabinet where<br>the network switch is installed.',
      info_do_80: 'A distance up to 80 meters does not require a power supply in the housing.',
      info_po_80: 'In the case of significant distances from DSO , a local power supply is required',
      glebokosc_szafy_info: 'Cabinet depth: 600 or 800mm<br>depending on the cabinet height.',
      info_rabat: 'To get discount for voice alarm system, please contact our sales team by phone (14) 610-19-41, or e-mail: sales@pulsar.pl.',
      info_akum: 'The ability to choose the battery pack, according to your needs.',
      info_coop: 'The program developed in collaboration with engineers from the',
      other_akum: 'Other batteries that meet the VAS configuration',
      wariant1_title: 'Option 1 - "In the cabinet".',
      wariant1: 'Microphone mounted in the VAS cabinet.',
      wariant2_title: 'Option 2 - "Outside the VAS cabinet".',
      wariant2: 'Microphone mounted outside the VAS cabinet.',
      wariant3_title: 'Option 3 - "In the enclosure".',
      wariant3: 'Firefighter`s microphone mounted in the DSOS24VPU external enclosure.',
      wariant4_title: 'Option 4 - "in the enclosure with the power supply unit"',
      wariant4: 'Firefighter`s microphone mounted in the DSOS24V external enclosure.',
      wariant5_title: 'Option 5 - "in the enclosure with the external power supply unit"',
      wariant5: 'Firefighter`s microphone is mounted outside the VAS cabinet and supplied from the EN54-2A17 external power supply.',
      info_system_dso: ' The power supply system of the VAS The power supply system of the VAS The DSOP24 power supply system is designed for uninterrupted supply of Voice Alarm Systems requiring stabilized voltage of 24V DC (-15%, +20%). In addition to the standard equipment of the DSOP24V system, a number of additional features and tools have been added to assist in the selection of equipment, pricing, installation, and commissioning. The system is operated exclusively by the installer<br>– a simple and intuitive procedure for battery calibration, VAS system verification, and checking the batteries. Remote monitoring of the VAS using the embedded Web server is carried out online via a web browser from a PC. The CONFI-DSO application - a public tool for the development and selection of components of the VAS:<br>- On-line collaboration, the ability to save to disk, etc. - The VAS power supplies available in four power levels: 320W / 500W / 750W / 1000W<br>- Proper selection of batteries<br>– 10 different capacities from 35Ah to 230Ah<br>- The number of strings (circuits) of batteries is limited to a maximum of two. To get discount for voice alarm system, please contact our sales team. The current discounts do not apply to the system presented above. ',
      wersja_2_4: '',
      wersja_2_3: '',
      wersja_2_2: '',
      // ---------------------------------------------------------- POLA DO DRUKU
      sys_zasilania: 'VAS Power Supply system',
      system_zasilania: 'DSOP24V Power Supply system',
      wydruk: 'CONFIG-DSO printout',
      trans: '',
      linie_glosnikowe: 'Loudspeaker lines monitored using a pilot tone',
      wyposazenie: 'Additional equipment:',
      txtAWO506: 'AWO506 - enclosure for loudspeaker line supervision of VAS',
      txtDSOS24VPU: 'DSOS24VPU - enclosure for firefighter’s microphone',
      txtDSOS24V: 'DSOS24V - firefighter’s microphone power supply',
      txtEN54_2A17: 'EN54-2A17 - power supply',
      txtAWZ627: 'AWZ627 - power supply adapter',
      copyright: 'Copyright © Pulsar Sp.j. 1994÷2017. All rights reserved.',
      obudowa_mikrofonu: 'Enclosure for firefighter’s microphone.',
      zasilacz_mikrofonu: 'Firefighter’s microphone power supply.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/messages.js